import { motion } from "framer-motion";
import { Building2, Mail, Phone, Globe } from "lucide-react";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import GlobalHeader from "@/components/GlobalHeader";

export default function Impressum() {
  return (
    <div className="min-h-screen bg-gradient-to-b from-background to-secondary/20">
      {/* Global Header */}
      <GlobalHeader />
      
      <div className="container mx-auto px-4 py-12 max-w-4xl pt-24">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          className="space-y-8"
        >
          {/* Header */}
          <div className="text-center space-y-4">
            <h1 className="text-4xl md:text-5xl font-bold">Impressum</h1>
            <p className="text-muted-foreground">
              Angaben gemäß § 5 TMG
            </p>
          </div>

          {/* Company Info */}
          <div className="bg-card rounded-2xl p-8 border shadow-sm space-y-6">
            <div className="flex items-start gap-4">
              <Building2 className="w-6 h-6 text-primary mt-1 flex-shrink-0" />
              <div className="space-y-2">
                <h2 className="text-xl font-bold">mokiplaner.com</h2>
                <div className="text-muted-foreground space-y-1">
                  <p>Betrieben von: Alexander Rudi & Kristina Rudi</p>
                  <p>Nordstormarnstraße 10</p>
                  <p>23858 Wesenberg</p>
                  <p>Deutschland</p>
                </div>
              </div>
            </div>

            <div className="h-px bg-border" />

            {/* Contact */}
            <div className="space-y-4">
              <h3 className="font-semibold text-lg">Kontakt</h3>
              
              <div className="flex items-center gap-3">
                <Phone className="w-5 h-5 text-primary" />
                <a href="tel:045336090371" className="hover:text-primary transition-colors">
                  045336090371
                </a>
              </div>

              <div className="flex items-center gap-3">
                <Mail className="w-5 h-5 text-primary" />
                <a href="mailto:info@mokiplaner.com" className="hover:text-primary transition-colors">
                  info@mokiplaner.com
                </a>
              </div>

              <div className="flex items-center gap-3">
                <Globe className="w-5 h-5 text-primary" />
                <a href="https://mokiplaner.com" target="_blank" rel="noopener noreferrer" className="hover:text-primary transition-colors">
                  mokiplaner.com
                </a>
              </div>
            </div>

            <div className="h-px bg-border" />

            {/* Legal Info */}
            <div className="space-y-4">
              <h3 className="font-semibold text-lg">Rechtliche Hinweise</h3>
              <div className="text-muted-foreground space-y-2 text-sm">
                <p>
                  <strong>Verantwortlich für den Inhalt nach § 55 Abs. 2 RStV:</strong><br />
                  Alexander Rudi<br />
                  Nordstormarnstraße 10<br />
                  23858 Wesenberg
                </p>
                <p>
                  <strong>Haftungsausschluss:</strong><br />
                  Die Inhalte unserer Seiten wurden mit größter Sorgfalt erstellt. Für die Richtigkeit, Vollständigkeit und Aktualität der Inhalte können wir jedoch keine Gewähr übernehmen.
                </p>
              </div>
            </div>
          </div>

          {/* Back Button */}
          <div className="text-center">
            <Link to="/">
              <Button variant="outline" className="rounded-full">
                Zurück zur Startseite
              </Button>
            </Link>
          </div>
        </motion.div>
      </div>
    </div>
  );
}
